<template lang="pug">
  .b-node__head.-hide-parent(
    :class="elementClasses"
    @dragstart="dragStart"
    @dragend="dragEnd"
    @dragover="dragOver"
    @dragenter="dragEnter"
    @dragleave="dragLeave"
    @click.stop="focusRelated"
    :name="`record-${item.id}`"
  )
    .b-node-head__inner
      .b-node__name(v-if="!getRelatedToItem") {{item._label}}
      template(v-else)
        div
          SVGIcon(:path="mdiLink")
        .b-node__name {{getRelatedToItem._label}}
      NodeAudio(
        v-if="audioAllowed"
        :item="item"
      )
      .b-node-head__top-left
        NodeDeleteButton.-hide._bg(
          v-if="!item.isRoot && !draggingItem"
          :id="item.id"
        )
</template>

<script>
import { ELEMENTS_TYPES_ALLOWED_TEXT, ELEMENTS_TYPES_GROUPS } from '@/api/elements';
import NodeAudio from '@/components/node/NodeAudio';
import NodeDeleteButton from '@/components/node/NodeDeleteButton';
import { mdiLink } from '@mdi/js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import drag from '@/mixims/drag';
import SVGIcon from '@/components/icons/SVGIcon';

export default {
  name: 'NodeHead',
  components: {
    SVGIcon,
    NodeAudio,
    NodeDeleteButton,
  },
  mixins: [
    drag,
  ],
  props: {
    item: Object,
    audioAllowed: Boolean,
  },
  data() {
    return {
      mdiLink,
      isDragging: false,
      isDragOver: false,
      delay: 300,
      clicks: 0,
      timer: null,
    };
  },
  computed: {
    ...mapGetters('nodes', [
      'getItem',
    ]),
    ...mapFields('nodes', [
      'focusId',
      'focusIdInput',
      'draggingItem',
    ]),
    getRelatedToItem() {
      return this.getItem(this.item.relatedToItemId);
    },
    elementClasses() {
      return {
        '_rounded': !ELEMENTS_TYPES_ALLOWED_TEXT.includes(this.item.type)
          && !Object.keys(ELEMENTS_TYPES_GROUPS).includes(this.item.type),
      };
    },
  },
  methods: {
    ...mapActions('nodes', [
      'deleteNodes',
    ]),
    focusRelated() {
      if (!this.item.relatedToItemId) {
        return false;
      }

      const onClick = () => {
        this.focusId = this.item.relatedToItemId;
        this.focusIdInput = null;
      };

      const onDbClick = () => {
        this.focusId = null;
        this.focusIdInput = this.item.relatedToItemId;
      };

      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout( () => {
          onClick();
          this.clicks = 0;
        }, this.delay);
      } else {
        clearTimeout(this.timer);
        onDbClick();
        this.clicks = 0;
      }
    },
  },
};
</script>
